export default __webpack_public_path__ + "static/media/location.171f7c9f.svg";